import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header/Header";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";

const RootLayout = () => {
  const location = useLocation();
  const [showHeader, setShowHeader] = useState(true);

  useEffect(() => {
    // Check if the current path includes "/login" to hide the header
    setShowHeader(!location.pathname.includes("/login"));
  }, [location.pathname]); // Ensure pathname is the dependency

  return (
    <>
      {showHeader && <Header />}
      <Outlet />
      <ToastContainer />
    </>
  );
};

export default RootLayout;
